import React from 'react'
import { Tooltip, Button  } from 'antd';
import Icon from '@ant-design/icons';

class EMDTableColumnDetail extends React.Component {

  constructor(props) {
    super(props);
    this.onAction = this.onAction.bind(this);
  }

  onAction (e, record) {
    e.preventDefault();
    const {onAction} = this.props;
    if (onAction) onAction(record, "DETAIL");
  }

  render() {
    //console.log(this);
    const {value, row} = this.props;
    return (
      <span>
        {(row && Array.isArray(row.annotations)) && (
          <Tooltip title="Дополнительная информация по свойствам">
            <Button size="small" onClick={(e)=> {this.onAction(e, row)}}><Icon type="snippets" style={{ verticalAlign: "+0.125em"}}/></Button>
          </Tooltip>
          )}{value}
      </span>
    );
  }

}

export default EMDTableColumnDetail;